import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

/**
 * ProgressBarDrawerWrapper
 *
 * Wrapper for the drawers used in Res Flow ProgressBar
 *
 * @param {boolean} props.shouldScroll - conditionally applying styles for the drawer content
 * @param {string} props.children - children being rendered inside the Progress Bar Drawer wrapper
 *
 * @return {JSX}
 */
const ProgressBarDrawerWrapper = ({ shouldScroll, children }) => (
  <div className={cn('progress-bar__drawer-wrapper theme--light-blue', { 'should-scroll': shouldScroll })}>
    <div className='progress-bar__drawer-content'>{children}</div>
  </div>
);

export default ProgressBarDrawerWrapper;

ProgressBarDrawerWrapper.propTypes = {
  shouldScroll: PropTypes.bool,
  children: PropTypes.any,
};
